module.exports = "/_next/static/images/01-c544ec0bce1634510639890e6e831178.png";